<mat-selection-list #test [multiple]="false">
    <mat-list-option [selected]="false">
        <div class="list">
            <mat-icon class="icon">person</mat-icon>
            <span class="text">{{ 'USER.USERNAME' | translate }}: {{ authService.getUsername() }}</span>
        </div>
    </mat-list-option>
    <mat-list-option>
        <div class="list">
            <mat-icon class="icon">settings</mat-icon>
            <a [href]="accountUrl" target="_blank" class="links">{{ 'EDIT_ACCOUNT' | translate }}</a>
        </div>
    </mat-list-option>
    <mat-list-option (click)="authService.logout()">
        <div class="list">
            <mat-icon class="icon">logout</mat-icon>
            <span class="links">{{ 'LOGOUT' | translate }}</span>
        </div>
    </mat-list-option>
</mat-selection-list>
